import React, { useContext, useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom';
import { context } from '../App';
import ButtonwithEnter from './ButtonwithEnter';
import PageIndicator from './PageIndicator';
import Title from './Title';
import Warning from './Warning';
import { ReactComponent as Eye } from '../assets/eye.svg';
import { ReactComponent as Eyeoff } from '../assets/eye-off.svg';
import FiveStar from '../assets/five_star_rating.png';
import encryptPasswordWithKey from '../encryptPasswordWithKey';
import { toast } from 'react-toastify';
import { TiTickOutline } from "react-icons/ti";
import { TiTick } from "react-icons/ti";
import {
    DndContext,
    closestCenter,
    useSensor,
    useSensors,
    PointerSensor,
    TouchSensor,
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    useSortable,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { useParams, useSearchParams } from 'react-router-dom';
import Eula from './Eula';
import { Accordion, AccordionTab } from 'primereact/accordion';
import TAC from './TAC';

const SortableItem = ({ id }) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        padding: "10px 10px",
        margin: "4px 0",
        background: "#f0f0f0",
        border: "1px solid #ccc",
        borderRadius: "8px",
        // cursor: "grab",
        color: "black",
        fontSize: "14px",
        textAlign: "start",
        maxWidth: "400px",
        touchAction: "none",
        cursor: "grab",
    };

    return (
        <div className='priorityOrderDiv' ref={setNodeRef} {...attributes} {...listeners} style={style}  >
            <span style={{ cursor: "grab", color: "black", fontSize: "14px", marginRight: "10px" }}>☰</span>{id}
        </div>
    );
};

export default function PropertyOwner({ readyToSubmit }) {
    const {
        payload,
        setPayload,
        inputChangeHandler,
        token,
        slideCount,
        right_container,
        setSlideCount,
        submitClicked,
        passwordEyeHandler,
        confirmPasswordEyeHandler,
        passwordEye,
        confirmPasswordEye,
        showAgreement,
        setShowAgreement,
        validateInput,
        setSubmitClicked,
        referred,
        referredImg,
        redeemId,
        setAgreeEnabled,
        formatPhoneNumber,
        agreeEnabled
    } = useContext(context);

    const [searchParams] = useSearchParams()
    const userId = searchParams.get('userId');
    let redirectUrl = searchParams.get('redirectUrl');
    const { contactId } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [memberDetails, setMemberDetails] = useState(null)
    const [highlight, setHighlight] = useState(false);
    const [showMemberExistsModal, setShowMemberExistsModal] = useState(false);
    const formRef = useRef(null);
    const [index, setIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const itemsPerView = isMobile ? 1 : 2;
    const [isCheckboxError, setIsCheckboxError] = useState(false)

    function resetToSlide11() {
        // payload.will_you_be_using_the_app_for = { "will_you_be_using_the_app_for": "", "warning": false };
        payload.do_you_consider_real_estate_part_of_your_retirement_strategy = { "do_you_consider_real_estate_part_of_your_retirement_strategy": "", "warning": false };
        payload.choose_primary_goal = {
            "choose_primary_goal": [
                "Tax savings",
                "Ease of investment",
                "Cash flow",
                "Capital appreciation",
                "Legacy planning",
                "Home maintenance",
            ], "warning": false
        };
        payload.whats_your_goal_for_capital_appreciation = { "whats_your_goal_for_capital_appreciation": "", "warning": false };
        payload.when_do_you_want_to_achieve_this_capital_appreciation_goal = { "when_do_you_want_to_achieve_this_capital_appreciation_goal": "", "warning": false };
        payload.whats_your_goal_for_cash_flow = { "whats_your_goal_for_cash_flow": "", "warning": false };
        payload.when_do_you_want_to_achieve_this_cash_flow_goal = { "when_do_you_want_to_achieve_this_cash_flow_goal": "", "warning": false };
        payload.first_name = { "first_name": "", "warning": false };
        payload.last_name = { "last_name": "", "warning": false };
        payload.email = { "email": "", "warning": false, "text": "Enter a valid email" };
        payload.tac = { "tac": false, "warning": false };
        payload.password = { "password": "", "warning": false, "type": "password" };
        payload.confirm_password = { "confirm_password": "", "warning": false, "type": "password", "text": "Please fill this in" };
        setPayload({ ...payload });
        setSlideCount(11);
        setShowAgreement(true);
        setAgreeEnabled(false);
    }

    function slide11Handler() {
        let temp_payload = { ...payload };

        // if (validateInput(temp_payload, "radio", "will_you_be_using_the_app_for")) {
        //     setSubmitClicked(true);

        //     setTimeout(() => {
        //         setSubmitClicked(false);
        //         setSlideCount(slideCount + 1);
        //     }, [500]);
        // }
        // console.log("temp_payload", temp_payload);

        if (validateInput(temp_payload, "radio", "choose_primary_goal") && validateInput(temp_payload, "radio", "do_you_consider_real_estate_part_of_your_retirement_strategy")) {
            if ((temp_payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" || temp_payload.choose_primary_goal.choose_primary_goal[1] === "Capital appreciation") &&
                (temp_payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" || temp_payload.choose_primary_goal.choose_primary_goal[1] === "Cash flow")) {
                if (validateInput(temp_payload, "radio", "whats_your_goal_for_capital_appreciation") && validateInput(temp_payload, "radio", "when_do_you_want_to_achieve_this_capital_appreciation_goal") &&
                    validateInput(temp_payload, "radio", "whats_your_goal_for_cash_flow") && validateInput(temp_payload, "radio", "when_do_you_want_to_achieve_this_cash_flow_goal")) {
                    setSubmitClicked(true);

                    setTimeout(() => {
                        setSubmitClicked(false);
                        setSlideCount(slideCount + 1);
                    }, [500]);
                }
            } else if (temp_payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" || temp_payload.choose_primary_goal.choose_primary_goal[1] === "Capital appreciation") {
                if (validateInput(temp_payload, "radio", "whats_your_goal_for_capital_appreciation") && validateInput(temp_payload, "radio", "when_do_you_want_to_achieve_this_capital_appreciation_goal")) {
                    setSubmitClicked(true);

                    setTimeout(() => {
                        setSubmitClicked(false);
                        setSlideCount(slideCount + 1);
                    }, [500]);
                }
            } else if (temp_payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" || temp_payload.choose_primary_goal.choose_primary_goal[1] === "Cash flow") {
                if (validateInput(temp_payload, "radio", "whats_your_goal_for_cash_flow") && validateInput(temp_payload, "radio", "when_do_you_want_to_achieve_this_cash_flow_goal")) {
                    setSubmitClicked(true);

                    setTimeout(() => {
                        setSubmitClicked(false);
                        setSlideCount(slideCount + 1);
                    }, [500]);
                }
            } else {
                setSubmitClicked(true);

                setTimeout(() => {
                    setSubmitClicked(false);
                    setSlideCount(slideCount + 1);
                }, [500]);
            }
        }
        setPayload({ ...temp_payload });
    }

    function slide12Handler() {
        let temp_payload = { ...payload };

        if (validateInput(temp_payload, "input", "first_name", 1) &&
            validateInput(temp_payload, "input", "last_name", 1) &&
            validateInput(temp_payload, "email", "email") &&
            validateInput(temp_payload, "checkbox", "tac")) {
            setSubmitClicked(true);

            setTimeout(() => {
                setSubmitClicked(false);
                setSlideCount(slideCount + 1);
            }, [500]);
        }
        setPayload({ ...temp_payload });
    }

    // console.log("referred", referred, redeemId);

    function submit() {
        let temp_payload = { ...payload };
        setIsCheckboxError(false);
        if (validateInput(temp_payload, "input", "first_name", 1) &&
            validateInput(temp_payload, "input", "last_name", 1) && validateInput(temp_payload, "email", "email") && readyToSubmit) {
            if (!agreeEnabled) {
                setIsCheckboxError(true);
                return;
            }
            setSubmitClicked(true);
            fetch("https://api.proinsight.com/publicKey", {
                method: "POST",
                headers: { "Authorization": token }
            })
                .then(resp => resp.json())
                .then(async key => {
                    console.log("key----", key);

                    if (key.public_key) {
                        let firstObj = {}
                        let url = "https://api.proinsight.com/submit_property_owner"
                        if (window.location.href.includes("homeowner.proinsight.com")) {
                            firstObj = {
                                "first_name": payload.first_name.first_name,
                                "last_name": payload.last_name.last_name,
                                "email": payload.email.email,
                                "user_id": memberDetails.user_id,
                                ...((referred && redeemId) && { "redeemid": redeemId })
                            }
                            url = "https://api.proinsight.com/create_user_from_profile"
                        } else {
                            firstObj = {
                                "first_name": payload.first_name.first_name,
                                "last_name": payload.last_name.last_name,
                                "email": payload.email.email,
                                "phone": payload.phone.phone,
                                // "will_you_be_using_the_app_for": payload.will_you_be_using_the_app_for.will_you_be_using_the_app_for,

                                "do_you_consider_real_estate_part_of_your_retirement_strategy": payload.do_you_consider_real_estate_part_of_your_retirement_strategy.do_you_consider_real_estate_part_of_your_retirement_strategy,
                                "choose_primary_goal": payload.choose_primary_goal.choose_primary_goal,
                                "whats_your_goal_for_capital_appreciation": (payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" || payload.choose_primary_goal.choose_primary_goal[1] === "Capital appreciation") ? payload.whats_your_goal_for_capital_appreciation.whats_your_goal_for_capital_appreciation : "",
                                "when_do_you_want_to_achieve_this_capital_appreciation_goal": (payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" || payload.choose_primary_goal.choose_primary_goal[1] === "Capital appreciation") ? payload.when_do_you_want_to_achieve_this_capital_appreciation_goal.when_do_you_want_to_achieve_this_capital_appreciation_goal : "",
                                "whats_your_goal_for_cash_flow": (payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" || payload.choose_primary_goal.choose_primary_goal[1] === "Cash flow") ? payload.whats_your_goal_for_cash_flow.whats_your_goal_for_cash_flow : "",
                                "when_do_you_want_to_achieve_this_cash_flow_goal": (payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" || payload.choose_primary_goal.choose_primary_goal[1] === "Cash flow") ? payload.when_do_you_want_to_achieve_this_cash_flow_goal.when_do_you_want_to_achieve_this_cash_flow_goal : "",
                                "is_property_owner_page": window.location.href.includes("propertyowner.proinsight") ? true : false,
                                ...((referred && redeemId) && { "redeemid": redeemId }),
                                ...(referred && { "introduced_by_name": payload.introduced_by_name.introduced_by_name, "introduced_by_email": payload.introduced_by_email.introduced_by_email })
                            }
                        }

                        let password_data = await encryptPasswordWithKey(key.public_key, payload.password.password);
                        let crm_password = await encryptPasswordWithKey(key.public_key_local, payload.password.password);

                        fetch(url, {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': token
                            },
                            body: JSON.stringify({ ...firstObj, ...password_data, crm_password })
                        })
                            .then(async resp => {
                                if (resp.ok) {
                                    if (window.location.href.includes("homeowner.proinsight.com")) {
                                        const data = await resp.json();
                                        setSlideCount(6);
                                        window.open(`https://proinsight.info/app-7001?email=${encodeURIComponent(payload.email.email)}&ticket=${encodeURIComponent(data.logintoken)}`, "_self");
                                    } else {
                                        setSlideCount(6);
                                        window.open("https://proinsight.info/app-7000", "_self");
                                    }
                                }
                                else {
                                    const error = await resp.json();
                                    console.log(error);
                                    setSubmitClicked(false);
                                    if (JSON.stringify(error).includes("A member with email")) {
                                        setShowMemberExistsModal(true);
                                    } else {
                                        toast.error(JSON.stringify(error));
                                        if (!window.location.href.includes("homeowner.proinsight.com")) {
                                            resetToSlide11();
                                        }
                                    }
                                }
                            })
                            .catch(err => {
                                setSubmitClicked(false);
                                window.open("https://proinsight.info/error", "_self");
                                alert("Something went wrong while submitting the data")
                                console.log(err);
                            })
                    }
                    else {
                        setSubmitClicked(false);
                    }
                })
                .catch(err => {
                    console.log(err);
                    setSubmitClicked(false);
                    alert("Something Went Wrong! try After Some time ")
                })
        }
        setPayload({ ...temp_payload });
    }

    function propertyOwnerPageSubmit() {
        // if (readyToSubmit) {
        let temp_payload = { ...payload };
        if (validateInput(temp_payload, "input", "first_name", 1) &&
            validateInput(temp_payload, "input", "last_name", 1) &&
            validateInput(temp_payload, "email", "email")) {
            setSubmitClicked(true);
            fetch("https://api.proinsight.com/publicKey", {
                method: "POST",
                headers: { "Authorization": token }
            })
                .then(resp => resp.json())
                .then(async key => {
                    if (key.public_key) {
                        let firstObj = {
                            "first_name": payload.first_name.first_name,
                            "last_name": payload.last_name.last_name,
                            "email": payload.email.email,
                            "phone": payload.phone.phone,
                            // "will_you_be_using_the_app_for": payload.will_you_be_using_the_app_for.will_you_be_using_the_app_for,
                            "do_you_consider_real_estate_part_of_your_retirement_strategy": payload.do_you_consider_real_estate_part_of_your_retirement_strategy.do_you_consider_real_estate_part_of_your_retirement_strategy,
                            "choose_primary_goal": payload.choose_primary_goal.choose_primary_goal,
                            "whats_your_goal_for_capital_appreciation": (payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" || payload.choose_primary_goal.choose_primary_goal[1] === "Capital appreciation") ? payload.whats_your_goal_for_capital_appreciation.whats_your_goal_for_capital_appreciation : "",
                            "when_do_you_want_to_achieve_this_capital_appreciation_goal": (payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" || payload.choose_primary_goal.choose_primary_goal[1] === "Capital appreciation") ? payload.when_do_you_want_to_achieve_this_capital_appreciation_goal.when_do_you_want_to_achieve_this_capital_appreciation_goal : "",
                            "whats_your_goal_for_cash_flow": (payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" || payload.choose_primary_goal.choose_primary_goal[1] === "Cash flow") ? payload.whats_your_goal_for_cash_flow.whats_your_goal_for_cash_flow : "",
                            "when_do_you_want_to_achieve_this_cash_flow_goal": (payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" || payload.choose_primary_goal.choose_primary_goal[1] === "Cash flow") ? payload.when_do_you_want_to_achieve_this_cash_flow_goal.when_do_you_want_to_achieve_this_cash_flow_goal : "",
                            "is_property_owner_page": true,
                            ...((referred && redeemId) && { "redeemid": redeemId }),
                            ...(referred && { "introduced_by_name": payload.introduced_by_name.introduced_by_name, "introduced_by_email": payload.introduced_by_email.introduced_by_email })
                        }

                        let password_data = await encryptPasswordWithKey(key.public_key, payload.password.password);
                        let crm_password = await encryptPasswordWithKey(key.public_key_local, payload.password.password);

                        fetch("https://api.proinsight.com/submit_property_owner", {
                            method: "POST",
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json',
                                'Authorization': token
                            },
                            body: JSON.stringify({ ...firstObj, ...password_data, crm_password })
                        })
                            .then(async resp => {
                                if (resp.ok) {
                                    setSlideCount(6);
                                    // window.open("https://proinsight.info/app-7000", "_self");
                                }
                                else {
                                    const error = await resp.json();
                                    console.log(error);
                                    toast.error(JSON.stringify(error));
                                    setSubmitClicked(false);
                                    resetToSlide11();
                                }
                            })
                            .catch(err => {
                                setSubmitClicked(false);
                                window.open("https://proinsight.info/error", "_self");
                                alert("Something went wrong while submitting the data")
                                console.log(err);
                            })
                    }
                    else {
                        setSubmitClicked(false);
                    }
                })
                .catch(err => {
                    console.log(err);
                    setSubmitClicked(false);
                    alert("Something Went Wrong! try After Some time ")
                })
        }
        setPayload({ ...temp_payload });
        // }
    }
    // console.log(payload);

    const [items, setItems] = useState([
        "Tax savings",
        "Ease of investment",
        "Cash flow",
        "Capital appreciation",
        "Legacy planning",
        "Home maintenance",
    ]);

    const sensors = useSensors(useSensor(PointerSensor));
    // const sensors = useSensors(
    //     useSensor(PointerSensor),
    //     useSensor(TouchSensor, {
    //         activationConstraint: {
    //             delay: 250,
    //             tolerance: 5,
    //         },
    //     })
    // );


    const handleDragEnd = (event) => {
        const { active, over } = event;
        if (active?.id !== over?.id) {
            const oldIndex = items.indexOf(active.id);
            const newIndex = items.indexOf(over.id);
            setItems(arrayMove(items, oldIndex, newIndex));
            inputChangeHandler("choose_primary_goal", arrayMove(items, oldIndex, newIndex))
        }
    };
    // console.log(items)

    const fetchMemberDetails = async () => {
        if (!contactId) {
            setError('No contact ID provided in the URL');
            setLoading(false);
            return;
        }

        let formattedContactId = contactId.replace("&", "-")

        try {
            const res = await fetch(`https://api.proinsight.com/get_user_by_name?name=${formattedContactId}`);
            if (!res.ok) {
                setLoading(false);
                throw new Error(`HTTP ${res.status}: Failed to load member details`);
            }
            const data = await res.json();
            // console.log("data---", data)
            setMemberDetails(data)

            if (!data?.user_id) {
                throw new Error('User ID not found in response');
            }

        } catch (err) {
            console.error("fetchMemberDetails error:", err);
            setLoading(false);
            setError('Could not load professionals data.');
        }
    };

    useEffect(() => {
        if (contactId) {
            fetchMemberDetails()
        }
    }, [contactId])

    const handleCTA = () => {
        formRef.current?.scrollIntoView({ block: "center" });
        formRef.current?.querySelector("input")?.focus();
        setHighlight(true);
        setTimeout(() => setHighlight(false), 300);
    };

    const testimonials = [
        {
            text: "I’m always asking people I trust who to call. This makes it so much easier.",
            image: "https://assets.cdn.filesafe.space/sIF5ZS1VxhUZsYbvq7gL/media/69e0f5baa2661c2e8f8c9a76.webp"
        },
        {
            text: "When something comes up, it’s nice knowing I already have a place to start.",
            image: "https://assets.cdn.filesafe.space/sIF5ZS1VxhUZsYbvq7gL/media/69e0f5baa2661c2e8f8c9a75.webp"
        },
        {
            text: "It’s amazing having trusted help in one place. Where has this been all my life?",
            image: "https://assets.cdn.filesafe.space/sIF5ZS1VxhUZsYbvq7gL/media/69e0f685c56ad2790819979f.webp"
        }
    ];


    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => {
                const maxIndex = testimonials.length - itemsPerView;
                return prev >= maxIndex ? 0 : prev + 1;
            });
        }, 5000);

        return () => clearInterval(interval);
    }, [itemsPerView]);


    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 600);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <>
            {!window.location.href.includes("homeowner.proinsight.com") && <PageIndicator currentPage={slideCount - 11} steps={3} />}

            <div className="left-container" style={{ display: window.location.href.includes("homeowner.proinsight.com") ? "flex" : "block", alignItems: "center" }} >
                <img className='11' style={{ display: slideCount === 11 ? "block" : "none" }}
                    src={(referred && referredImg) ? referredImg : "https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6655d126ef816ee29da4a24c.jpeg"}
                    alt="left-img" />

                <img style={{ display: slideCount === 12 ? "block" : "none" }} src="https://storage.googleapis.com/msgsndr/sIF5ZS1VxhUZsYbvq7gL/media/6876cd42d52f707593928162.webp" alt="left-img" />

                {/* <img style={{ display: slideCount === 13 ? "block" : "none" }} className={`${slideCount === 13 && "downloadAppImgDesktop"}`} src="https://assets.cdn.filesafe.space/sIF5ZS1VxhUZsYbvq7gL/media/69ca9830eab9f1b484c32de7.webp" alt="left-img" /> */}

                {/* ///////////////////////////////////////// */}
                {/* <img style={{ display: slideCount === 13 ? "block" : "none", objectFit: "contain", objectPosition: "center" }} className='downloadAppImg' src="https://assets.cdn.filesafe.space/sIF5ZS1VxhUZsYbvq7gL/media/69ab2054a4f763f6d05c2124.png" alt="left-img" /> */}
                {/* {memberDetails?.business || 'N/A'} — {memberDetails?.fullname || 'N/A'} */}

                {window.location.href.includes("homeowner.proinsight.com") && <div className='memberDetailsContainerSection' >
                    <div className='memberDetailsContainerDiv' >
                        {memberDetails ? <div className="card memberDetailsContainer" style={{
                            marginTop: "55px", fontSize: "16px", textAlign: "center",
                            display: "flex", justifyContent: "center", width: "100%"
                        }} >
                            <div className='memberDetailsDiv' style={{ border: "5px solid #DAB559", background: "white", borderRadius: "10px", width: "100%" }} >

                                {memberDetails?.avatar && <img
                                    src={memberDetails?.avatar}
                                    className='memberHeadShot'
                                    alt="Avatar Logo"
                                    style={{  objectFit: 'contain' }}
                                />}
                                <div>

                            <div className='memberDetailsRightDiv'>
                                {memberDetails?.logo && !memberDetails?.seeduser && (
                                    <div className='membershipCompanyLogo' style={{ marginBottom: '1rem' }}>
                                        <a
                                            href={memberDetails?.website_url?.split(',')[0]?.trim() || ''}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                display: 'flex',
                                                pointerEvents: memberDetails?.website_url?.split(',')[0]?.trim() || '' ? 'auto' : 'none',
                                                justifyContent: "center",
                                                margin: "0"
                                            }}
                                        >
                                            <img
                                                src={memberDetails?.logo}
                                                alt="Company Logo"
                                            />
                                        </a>
                                    </div>
                                )}

                                {memberDetails?.seeduser && (
                                    <div className='membershipCompanyLogo' style={{ marginBottom: '1rem' }}>
                                        <a
                                            href={memberDetails?.website_url?.split(',')[0]?.trim() || ''}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            style={{
                                                display: 'flex',
                                                pointerEvents: memberDetails?.website_url?.split(',')[0]?.trim() || '' ? 'auto' : 'none',
                                                justifyContent: "center"
                                            }}
                                        >
                                            <img
                                                src={"https://proinsightblobwestus.blob.core.windows.net/avatars/57a6e188-f359-4cdb-8e69-733bbe4fa898&t=2026-03-11T18_09_49"}
                                                alt="Company Logo"
                                                style={{ maxHeight: '70px', objectFit: 'contain', background: "white" }}
                                            />
                                        </a>
                                    </div>
                                )}

                                <div className='memberDetailsContact' style={{ padding: ".5rem 1.5rem", textAlign: "end" }} >
                                    <h3 style={{ color: "black", fontSize: "20px" }} >
                                        {memberDetails?.business || 'N/A'} — {memberDetails?.fullname || 'N/A'}
                                    </h3>

                                    <p className='professionName' style={{ color: "#535151", fontSize: "16px" }} >{memberDetails?.profession || ""}</p>
                                    <hr style={{ margin: '0.8rem 0', borderColor: '#ddd', width: "100%" }} />

                                    <p style={{ margin: '0.6rem 0' }}>
                                        <a className='memberPhone'
                                            href={`tel:${memberDetails?.phone}`}
                                            style={{ textDecoration: 'none', color: '#000', fontWeight: 400 }}
                                        >
                                            {formatPhoneNumber(memberDetails?.phone) || '—'}
                                        </a>
                                    </p>

                                    <div className='memberEmail' style={{ margin: '0.4rem 0', color: '#444', fontSize: "16px" }}>
                                        {memberDetails?.email || '—'}
                                    </div>
                                </div>
                            </div>
                            </div>
                            </div>
                        </div> :
                            <div className="grid" >
                                <div className="skeleton-card memberDetailsContainer" style={{ border: "5px solid #DAB559", marginTop: "80px", borderRadius: "10px", width: "380px" }} >
                                    <div className="skeleton skel-logo"></div>
                                    <div style={{ padding: ".5rem 1.5rem", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "10px" }}>
                                        <div className="skeleton skel-line" style={{ height: "22px", width: "85%", margin: 0 }} ></div>
                                        <div className="skeleton skel-line" style={{ height: "16px", width: "50%", margin: 0 }} ></div>
                                        <div className="skeleton skel-line" style={{ height: "2px", width: "100%", margin: "0.2rem 0" }} ></div>
                                        <div className="skeleton skel-line" style={{ height: "16px", width: "42%", margin: 0 }} ></div>
                                        <div className="skeleton skel-line" style={{ height: "16px", width: "62%", margin: 0 }} ></div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <div className='threeReasonsDiv' style={{ display: "flex", justifyContent: "center", marginTop: "40px" }} >
                        <div  >
                            {/* <div style={{ height: "1px", width: "100%", background: "white", marginBottom: "2rem" }} ></div> */}
                            <h3 className='darkBlueColor headerText' style={{ fontSize: "24px",  fontWeight: "700" }} >Everyone you need for your home or your estate, with <span style={{fontWeight: "700", color: "#DAB559"}} >real accountability from a professional you already trust. </span> </h3>

                            {/* <div className='accountabilityText' style={{ marginTop: "5px" }} ><span style={{ fontWeight: "700" }}> Real accountability, </span> <span className='darkBlueColor' style={{ fontWeight: "700", color: "#DAB559", marginTop: "10px" }} > via your trusted advisor.</span> </div> */}
                            {/* <div style={{ fontSize: "18px", width: "100%", marginTop: "15px" }}>Every pro on this list is vetted, and the person who invited you stays in the loop</div>
                            <div style={{ display: "flex", marginTop: "1rem", alignItems: "start" }} >
                                <TiTick style={{ fontSize: "30px", marginRight: "5px", color: "#DAB559" }} />
                                <div>
                                    <span style={{ fontSize: "18px", width: "100%", fontWeight: "500" }}>Vetted professionals</span> <br />
                                    <span className='tickMarkText' style={{ fontSize: "16px", width: "100%" }}>Every pro on this list meets ProInsight's standard, not random search results.</span>
                                </div>
                            </div>
                            <div style={{ display: "flex", marginTop: "1rem", alignItems: "start" }} >
                                <TiTick style={{ fontSize: "30px", marginRight: "5px", color: "#DAB559" }} />
                                <div>
                                    <span style={{ fontSize: "18px", width: "100%", fontWeight: "500" }}>Real accountability</span> <br />
                                    <span className='tickMarkText' style={{ fontSize: "16px", width: "100%" }}>Whoever invited you is notified when you book a pro, so someone's always watching how it goes.</span>
                                </div>
                            </div> */}
                            {/* <p style={{ display: "flex", alignItems: "center" }} ><TiTick style={{ fontSize: "30px", marginRight: "5px", color: "#DAB559" }} /> <span style={{ fontSize: "18px", width: "100%" }}>Built-in accountability — your referral source is always in the loop</span></p>
                            <p style={{ display: "flex", alignItems: "center" }} ><TiTick style={{ fontSize: "30px", marginRight: "5px", color: "#DAB559" }} /> <span style={{ fontSize: "18px", width: "100%" }}>One place for every trusted pro you need for your home or your estate</span> </p> */}
                        </div>
                    </div>
                    <div
                        className="socialProofSection"
                        style={{
                            paddingBottom: "5px",
                            overflow: "hidden",
                            display: "flex",
                            margin: "25px 60px",
                            justifyContent: "center",
                            marginTop: "40px",
                            gap: ".75rem"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                transform: `translateX(-${isMobile ? index * 100 : index * 50}%)`,
                                transition: "transform 0.5s ease-in-out"
                            }}
                        >
                            {testimonials.map((item, i) => (
                                <div
                                    key={i}
                                    style={{
                                        minWidth: isMobile ? "100%" : "50%",
                                        padding: "0 4px",
                                        boxSizing: "border-box",
                                        display: "flex"
                                    }}
                                >
                                    <div
                                        style={{
                                            background: "white",
                                            padding: "10px",
                                            borderRadius: "5px",
                                            width: "100%"
                                        }}
                                    >
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                            <img
                                                style={{ width: "25px", borderRadius: "50px", pointerEvents: "none" }}
                                                src={item.image}
                                            />
                                            <img
                                                style={{ height: "25px", marginLeft: "10px" }}
                                                src={FiveStar}
                                            />
                                        </div>

                                        <div
                                            style={{
                                                fontSize: "13px",
                                                color: "black",
                                                marginTop: "5px"
                                            }}
                                        >
                                            {item.text}
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>}
                {/* ///////////////////////////////////////// */}
            </div>

            <div className={`right-container right form-container ${highlight ? "highlight" : ""}`} style={{ zIndex: "10" }} ref={right_container}>
                {
                    slideCount === 11
                    &&
                    <div className="slide slide11 primary_goal" style={{ textAlign: "start" }} >

                        {/* <Title pagenum="1" title="Primary Goal Selection" /> */}
                        <div style={{ fontSize: "20px", paddingBottom: "15px" }} >As your trusted advisor, I want to help you reach your objectives.</div>
                        <div >
                            <label htmlFor="f-name">Do you consider real estate part of your retirement strategy? </label>
                            <div className="using-for">
                                <div className='radio-label-container'>
                                    <input
                                        type="checkbox"
                                        id='yes'
                                        value="Yes"
                                        checked={payload.do_you_consider_real_estate_part_of_your_retirement_strategy.do_you_consider_real_estate_part_of_your_retirement_strategy === 'Yes'}
                                        onChange={(e) => { inputChangeHandler("do_you_consider_real_estate_part_of_your_retirement_strategy", e.target.value) }} />
                                    <label htmlFor='yes'>Yes</label>
                                </div>
                                <div className='radio-label-container'>
                                    <input
                                        type="checkbox"
                                        id='no'
                                        value="No"
                                        checked={payload.do_you_consider_real_estate_part_of_your_retirement_strategy.do_you_consider_real_estate_part_of_your_retirement_strategy === 'No'}
                                        onChange={(e) => { inputChangeHandler("do_you_consider_real_estate_part_of_your_retirement_strategy", e.target.value) }} />
                                    <label htmlFor='no'>No</label>
                                </div>

                                <Warning display={payload.do_you_consider_real_estate_part_of_your_retirement_strategy.warning} />
                            </div>
                        </div>

                        <label htmlFor="f-name"  >Order the goals below by your priority:</label>

                        <div style={{ marginTop: "1rem" }} >
                            <DndContext
                                sensors={sensors}
                                collisionDetection={closestCenter}
                                onDragEnd={handleDragEnd}
                            >
                                <SortableContext items={items} strategy={verticalListSortingStrategy}>
                                    {items.map((item) => (
                                        <SortableItem key={item} id={item} />
                                    ))}
                                </SortableContext>
                            </DndContext>
                        </div>
                        {/* <ButtonwithEnter state={slideCount} setState={setSlideCount} onClickFn={slide11Handler} indexId="11" text="NEXT" submitState={submitClicked} /> */}
                        {/* <Title pagenum="1" title="What is your goal for capital appreciation:" /> */}
                        <div style={{ display: "flex", flexDirection: "column" }} >
                            {(payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" || payload.choose_primary_goal.choose_primary_goal[1] === "Capital appreciation") &&
                                <div style={{ order: payload.choose_primary_goal.choose_primary_goal[0] === "Capital appreciation" ? "-1" : "0" }} >
                                    <div style={{ marginTop: "4rem" }} >
                                        <label htmlFor="f-name">What is your goal for capital appreciation: </label>
                                        <div className="using-for" style={{ marginBottom: "1.5rem" }} >
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='one_million_equity'
                                                    value="One million equity"
                                                    checked={payload.whats_your_goal_for_capital_appreciation.whats_your_goal_for_capital_appreciation === 'One million equity'}
                                                    onChange={(e) => { inputChangeHandler("whats_your_goal_for_capital_appreciation", e.target.value) }} />
                                                <label htmlFor='one_million_equity'>One million equity</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='million_equity'
                                                    value="1-5 million equity"
                                                    checked={payload.whats_your_goal_for_capital_appreciation.whats_your_goal_for_capital_appreciation === '1-5 million equity'}
                                                    onChange={(e) => { inputChangeHandler("whats_your_goal_for_capital_appreciation", e.target.value) }} />
                                                <label htmlFor='million_equity'>1-5 million equity</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='million_10_equity'
                                                    value="10+ million equity"
                                                    checked={payload.whats_your_goal_for_capital_appreciation.whats_your_goal_for_capital_appreciation === '10+ million equity'}
                                                    onChange={(e) => { inputChangeHandler("whats_your_goal_for_capital_appreciation", e.target.value) }} />
                                                <label htmlFor='million_10_equity'>10+ million equity</label>
                                            </div>

                                        </div>
                                        <Warning display={payload.whats_your_goal_for_capital_appreciation.warning} />
                                    </div>

                                    <div style={{ marginTop: "4rem" }} >
                                        <label htmlFor="f-name">By when do you want to achieve this goal for Capital appreciation:</label>
                                        <div className="using-for">
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='within_1_year'
                                                    value="Within 1 year"
                                                    checked={payload.when_do_you_want_to_achieve_this_capital_appreciation_goal.when_do_you_want_to_achieve_this_capital_appreciation_goal === 'Within 1 year'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_capital_appreciation_goal", e.target.value) }} />
                                                <label htmlFor='within_1_year'>Within 1 year</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='within_3_years'
                                                    value="Within 3 years"
                                                    checked={payload.when_do_you_want_to_achieve_this_capital_appreciation_goal.when_do_you_want_to_achieve_this_capital_appreciation_goal === 'Within 3 years'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_capital_appreciation_goal", e.target.value) }} />
                                                <label htmlFor='within_3_years'>Within 3 years</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='within_5_years'
                                                    value="Within 5 years"
                                                    checked={payload.when_do_you_want_to_achieve_this_capital_appreciation_goal.when_do_you_want_to_achieve_this_capital_appreciation_goal === 'Within 5 years'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_capital_appreciation_goal", e.target.value) }} />
                                                <label htmlFor='within_5_years'>Within 5 years</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='in_10_years'
                                                    value="In 10+ years"
                                                    checked={payload.when_do_you_want_to_achieve_this_capital_appreciation_goal.when_do_you_want_to_achieve_this_capital_appreciation_goal === 'In 10+ years'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_capital_appreciation_goal", e.target.value) }} />
                                                <label htmlFor='in_10_years'>In 10+ years</label>
                                            </div>

                                            <Warning display={payload.when_do_you_want_to_achieve_this_capital_appreciation_goal.warning} />
                                        </div>
                                    </div>

                                </div>
                            }


                            {(payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" || payload.choose_primary_goal.choose_primary_goal[1] === "Cash flow") &&
                                <div style={{ order: payload.choose_primary_goal.choose_primary_goal[0] === "Cash flow" ? "-1" : "0" }}>
                                    <div style={{ marginTop: "4rem" }} >
                                        <label htmlFor="f-name">What is your goal for Cash flow: </label>
                                        <div className="using-for">
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='annually_50_cash_flow'
                                                    value="$50,000 annually"
                                                    checked={payload.whats_your_goal_for_cash_flow.whats_your_goal_for_cash_flow === '$50,000 annually'}
                                                    onChange={(e) => { inputChangeHandler("whats_your_goal_for_cash_flow", e.target.value) }} />
                                                <label htmlFor='annually_50_cash_flow'>$50,000 annually</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='annually_cash_flow_5010'
                                                    value="$50,001-$100,000 annually"
                                                    checked={payload.whats_your_goal_for_cash_flow.whats_your_goal_for_cash_flow === '$50,001-$100,000 annually'}
                                                    onChange={(e) => { inputChangeHandler("whats_your_goal_for_cash_flow", e.target.value) }} />
                                                <label htmlFor='annually_cash_flow_5010'>$50,001-$100,000 annually</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='annually_cash_flow_10'
                                                    value="$100,000+ annually"
                                                    checked={payload.whats_your_goal_for_cash_flow.whats_your_goal_for_cash_flow === '$100,000+ annually'}
                                                    onChange={(e) => { inputChangeHandler("whats_your_goal_for_cash_flow", e.target.value) }} />
                                                <label htmlFor='annually_cash_flow_10'>$100,000+ annually</label>
                                            </div>
                                        </div>
                                        <Warning display={payload.whats_your_goal_for_cash_flow.warning} />
                                    </div>
                                    <div style={{ marginTop: "4rem" }}>
                                        <label htmlFor="f-name">By when do you want to achieve this goal for Cash flow:</label>
                                        <div className="using-for">
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='within_1_year_cash_flow'
                                                    value="Within 1 year"
                                                    checked={payload.when_do_you_want_to_achieve_this_cash_flow_goal.when_do_you_want_to_achieve_this_cash_flow_goal === 'Within 1 year'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_cash_flow_goal", e.target.value) }} />
                                                <label htmlFor='within_1_year_cash_flow'>Within 1 year</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='within_3_years_cash_flow'
                                                    value="Within 3 years"
                                                    checked={payload.when_do_you_want_to_achieve_this_cash_flow_goal.when_do_you_want_to_achieve_this_cash_flow_goal === 'Within 3 years'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_cash_flow_goal", e.target.value) }} />
                                                <label htmlFor='within_3_years_cash_flow'>Within 3 years</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='within_5_years_cash_flow'
                                                    value="Within 5 years"
                                                    checked={payload.when_do_you_want_to_achieve_this_cash_flow_goal.when_do_you_want_to_achieve_this_cash_flow_goal === 'Within 5 years'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_cash_flow_goal", e.target.value) }} />
                                                <label htmlFor='within_5_years_cash_flow'>Within 5 years</label>
                                            </div>
                                            <div className='radio-label-container'>
                                                <input
                                                    type="checkbox"
                                                    id='in_10_years_cash_flow'
                                                    value="In 10+ years"
                                                    checked={payload.when_do_you_want_to_achieve_this_cash_flow_goal.when_do_you_want_to_achieve_this_cash_flow_goal === 'In 10+ years'}
                                                    onChange={(e) => { inputChangeHandler("when_do_you_want_to_achieve_this_cash_flow_goal", e.target.value) }} />
                                                <label htmlFor='in_10_years_cash_flow'>In 10+ years</label>
                                            </div>

                                            <Warning display={payload.when_do_you_want_to_achieve_this_cash_flow_goal.warning} />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div style={{ marginTop: "5rem" }} >
                            <ButtonwithEnter state={slideCount} setState={setSlideCount} onClickFn={slide11Handler} indexId="11" text="NEXT" submitState={submitClicked} />
                        </div>
                    </div>
                }

                {
                    slideCount === 12
                    &&
                    <div className="slide slide12">
                        <form className="contact-info-form">
                            {/* <Title pagenum="2" title="Let's start by ensuring we have your correct contact information." /> */}
                            {/* <h3>Let's start by ensuring we have your correct contact information.</h3> */}
                            {!window.location.href.includes("propertyowner.proinsight") ? <h3>Next, please enter your contact information so we can keep our conversations aligned with your goals.</h3> :
                                <h3>Let’s make sure I’ve got your best contact info.</h3>
                            }
                            <div>
                                <label htmlFor="f-name">First Name *</label>
                                <input id='f-name'
                                    value={payload.first_name.first_name}
                                    onChange={(e) => { inputChangeHandler("first_name", e.target.value) }}
                                    type="text" placeholder='Jane'
                                    required />
                                <Warning display={payload.first_name.warning} />
                            </div>

                            <div>
                                <label htmlFor="l-name">Last Name *</label>
                                <input
                                    id='l-name'
                                    type="text"
                                    value={payload.last_name.last_name}
                                    onChange={(e) => inputChangeHandler("last_name", e.target.value)}
                                    placeholder='Smith'
                                    required />
                                <Warning display={payload.last_name.warning} />
                            </div>

                            <div>
                                <label htmlFor="email">Email *</label>
                                <input
                                    id='email'
                                    type="email"
                                    value={payload.email.email}
                                    onChange={(e) => { inputChangeHandler("email", e.target.value) }}
                                    placeholder='name@example.com'
                                    required />
                                <Warning display={payload.email.warning} text={payload.email.text} />
                            </div>

                            <div>
                                <label htmlFor="phone">Phone </label>
                                <input
                                    id='phone'
                                    type="tel"
                                    value={payload.phone.phone}
                                    onChange={(e) => { inputChangeHandler("phone", formatPhoneNumber(e.target.value)) }}
                                    placeholder='(201) 555-0123'
                                    required />
                                <Warning display={payload.phone.warning} text={payload.phone.text} />
                            </div>

                            {!window.location.href.includes("propertyowner.proinsight") && <div style={{ display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "start" }}>
                                <input
                                    id='tac'
                                    style={{ margin: "1rem 1rem 0 0" }}
                                    checked={payload.tac.tac}
                                    onChange={(e) => { inputChangeHandler("tac", e.target.checked) }}
                                    type="checkbox" />
                                {/* {!window.location.href.includes("propertyowner.proinsight") ?  */}
                                <label htmlFor='tac'>I agree to <a href="https://proinsight.com/termsconditions/" rel='noreferrer' target='_blank'>terms & conditions</a> provided by the company. By providing my email, I agree to receive emails from the business.</label>
                                {/* <label htmlFor='tac'>I agree to have you stay in contact with me.</label> */}
                                {/* } */}

                                <Warning display={payload.tac.warning} />
                            </div>}
                        </form>
                        {/* <ButtonwithEnter state={slideCount} setState={setSlideCount} onClickFn={slide12Handler} indexId="12" text="NEXT" submitState={submitClicked} /> */}
                        {window.location.href.includes("propertyowner.proinsight") ? <ButtonwithEnter indexId="13" text="SUBMIT" onClickFn={propertyOwnerPageSubmit} submitState={submitClicked} /> :
                            <ButtonwithEnter state={slideCount} setState={setSlideCount} onClickFn={slide12Handler} indexId="12" text="NEXT" submitState={submitClicked} />
                        }

                    </div>
                }

                {
                    (!showAgreement && slideCount === 13)
                    &&
                    <div ref={formRef} className='slide slide13 ' >
                        {!window.location.href.includes("homeowner.proinsight.com") && <Title pagenum="3" title="Create your ProInsight account" />}
                        {window.location.href.includes("homeowner.proinsight.com") && <div style={{ marginBottom: "2rem" }} >
                            <div className='createFreeAccountText' style={{ fontSize: "22px", fontWeight: "400" }} >Create your Free Account</div>
                            <div className='createFreeAccountHr' style={{ height: "2px", width: "250px", background: "#DAB559" }} ></div>
                            <p className='createFreeAccountText' style={{ fontSize: "15px", marginBottom: "2rem", marginTop: "10px" }} >Takes under a minute. No password to remember.</p>

                            <div className='mobileCreateFreeAccountBtn' style={{ display: "none", justifyContent: "center", marginBottom: "25px" }} >
                                <div className='createYourAccount' style={{ fontSize: "22px", fontWeight: "600" }} >Create your Free Account</div>
                                <p className='takesMinute' style={{ fontSize: "16px", marginBottom: "2rem", marginTop: "5px" }} >Takes under a minute. No password to remember.</p>
                            </div>
                            {/* <hr style={{marginBottom: "2rem", background: "#DAB559"}} /> */}
                            <div>
                                {/* <label htmlFor="f-name">First Name *</label> */}
                                <input id='f-name'
                                    value={payload.first_name.first_name}
                                    onChange={(e) => { inputChangeHandler("first_name", e.target.value) }}
                                    type="text" placeholder='First Name *'
                                    required />
                                <Warning display={payload.first_name.warning} />
                            </div>

                            <div style={{ margin: "1rem 0rem" }} >
                                {/* <label htmlFor="l-name">Last Name *</label> */}
                                <input
                                    id='l-name'
                                    type="text"
                                    value={payload.last_name.last_name}
                                    onChange={(e) => inputChangeHandler("last_name", e.target.value)}
                                    placeholder='Last Name *'
                                    required />
                                <Warning display={payload.last_name.warning} />
                            </div>

                            {/* <label htmlFor="email">Email *</label> */}
                            <input
                                id='email'
                                type="email"
                                value={payload.email.email}
                                onChange={(e) => { inputChangeHandler("email", e.target.value) }}
                                placeholder='Email *'
                                autoComplete="new-password"
                                autoCapitalize="off"
                                spellCheck="false"
                                required />
                            <Warning display={payload.email.warning} text={payload.email.text} />
                        </div>}
                        <label htmlFor="password">Choose a 4-6 digit numeric PIN to secure your account</label>
                        <div className="password homeownerPagePassword">
                            <div className='password-container'>
                                <input
                                    type={payload.password.type}
                                    className='password-input'
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    maxLength={6}
                                    value={payload.password.password}
                                    onChange={(e) => { inputChangeHandler("password", e.target.value.replace(/\D/g, '').slice(0, 6)) }}
                                    placeholder='PIN' />
                                {
                                    passwordEye ? <Eye className='password-eye' onClick={passwordEyeHandler} /> : <Eyeoff className='password-eyeoff' onClick={passwordEyeHandler} />
                                }
                            </div>
                            <div className='confirm-password-container'>
                                <input
                                    type={payload.confirm_password.type}
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    maxLength={6}
                                    value={payload.confirm_password.confirm_password}
                                    onChange={(e) => { inputChangeHandler("confirm_password", e.target.value.replace(/\D/g, '').slice(0, 6)) }}
                                    placeholder='Confirm PIN' />
                                {
                                    confirmPasswordEye ? <Eye className='confirm-password-eye' onClick={confirmPasswordEyeHandler} /> : <Eyeoff className='confirm-password-eyeoff' onClick={confirmPasswordEyeHandler} />
                                }
                            </div>

                            {(() => { readyToSubmit = /^\d{4,6}$/.test(payload.password.password) && payload.password.password === payload.confirm_password.confirm_password; return null; })()}
                            {payload.password.password && !/^\d{4,6}$/.test(payload.password.password) && (
                                <p style={{ color: '#888', fontSize: '13px', margin: '4px 0 0' }}>Enter a 4–6 digit numeric PIN</p>
                            )}
                            {payload.password.password && payload.confirm_password.confirm_password && payload.password.password !== payload.confirm_password.confirm_password && (
                                <p style={{ color: '#888', fontSize: '13px', margin: '4px 0 0' }}>PINs do not match</p>
                            )}
                        </div>
                        {/* <Eula /> */}
                        {/* <div className="eula homeOwnerEULA">
                            <Accordion>
                                <AccordionTab headerTemplate={
                                    <div className='headerTemplate'>
                                        <span style={{ fontSize: "16px" }} >Terms & Conditions</span>
                                    </div>
                                }>
                                    <Eula />
                                </AccordionTab>

                                <AccordionTab header="End User License Agreement (EULA)">
                                    <TAC />
                                </AccordionTab>
                            </Accordion>
                        </div> */}
                        <div className="checkbox-container">
                            <input type="checkbox" checked={agreeEnabled} id='checkbox' onChange={() => setAgreeEnabled(!agreeEnabled)} />
                            <label htmlFor="checkbox">I have read and agree with <a href='https://proinsight.com/terms-and-conditions-3/' target="_blank" rel="noreferrer">terms and conditions</a> and <a href='https://proinsight.com/eula/' target="_blank" rel="noreferrer">EULA</a></label>
                        </div>
                        {isCheckboxError && <Warning display={!agreeEnabled} text={"Please accept Terms and Conditions"} />}
                        {/* <div style={{opacity: !agreeEnabled && "0.5", pointerEvents: !agreeEnabled && "none"}} > */}
                        <ButtonwithEnter indexId="13" text="SUBMIT" onClickFn={submit} submitState={submitClicked} />
                        {/* </div> */}
                        <div style={{ textAlign: 'start', marginTop: '10px', fontSize: '14px', color: '#444' }}>
                            Already have an account? <a href='https://app.proinsight.com/login' target="_blank" rel="noreferrer">Log in</a>
                        </div>

                    </div>
                }
            </div>

            {showMemberExistsModal && createPortal(
                <div
                    style={{
                        position: 'fixed',
                        inset: 0,
                        background: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000,
                    }}
                    onClick={() => setShowMemberExistsModal(false)}
                >
                    <div
                        style={{
                            background: 'white',
                            borderRadius: '12px',
                            padding: '32px',
                            maxWidth: '400px',
                            width: '90%',
                            textAlign: 'center',
                            position: 'relative',
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            onClick={() => setShowMemberExistsModal(false)}
                            style={{
                                position: 'absolute',
                                top: '10px',
                                right: '10px',
                                width: '32px',
                                height: '32px',
                                borderRadius: '50%',
                                background: 'rgba(0,0,0,0.07)',
                                border: 'none',
                                fontSize: '20px',
                                lineHeight: '1',
                                cursor: 'pointer',
                                color: '#666',
                            }}
                        >
                            ×
                        </button>
                        <h3 style={{ margin: '0 0 12px', color: 'black' }}>Account already exists</h3>
                        <div style={{ margin: '0 0 24px', color: '#444', fontSize: "16px" }}>An account with the email <strong style={{ fontSize: '16px' }}>{payload.email.email}</strong> already exists. Please log in to ProInsight Web to continue.</div>
                        <div className='buttonwithenter' style={{ justifyContent: 'center' }} onClick={()=> window.open(`https://app.proinsight.com/login`, '_blank')}>
                                <button className='webAppBtn'>Open ProInsight Web</button>
                        </div>
                    </div>
                </div>,
                document.body
            )}
        </>
    )
}
